<template>
    <div class="flex flex-col h-full w-full">
        <!--
        <div v-if="$route.query.comingFrom == 'dashboard'" @click="this.$router.push(`/posts/${pjwt.token}`)" class="self-start cursor-pointer ml-4 font-bold text-xl">Back</div>
        <div v-else @click="$router.push(`/feed/${pjwt.token}`)">Back</div>
        -->
        <!--<div @click="this.$router.back()" class="self-start cursor-pointer text-lg border border-solid border-gray-600 hover:bg-gray-200 hover:text-gray-900 hover:border-gray-900 text-gray-600 pt-3 pb-3 pl-3 pr-3 rounded-md mb-4 ml-7"> ← Back</div>-->
        <div @click="this.$router.back()" class=" bg-gray-100 dark:bg-opacity-0 dark:border dark:border-solid dark:border-gray-100 dark:hover:text-gray-600 border-0 py-1 px-3 cursor-pointer focus:outline-none self-start ml-7 mb-4 hover:bg-gray-200 rounded text-base mt-4 md:mt-0"> ← Back</div>
        <!--class="inline-flex items-center bg-gray-100 dark:bg-opacity-0 dark:border dark:border-solid dark:border-gray-100 dark:hover:text-gray-600 border-0 py-1 px-3 focus:outline-none hover:bg-gray-200 rounded text-base mt-4 md:mt-0"-->
        <div class="flex flex-col dark:bg-slate-800">
            <div v-if="!postLoading" class="p-4 md:w-2/3 self-center">
                <div class="h-full border-2 border-gray-300 border-opacity-60 rounded-lg overflow-hidden w-full flex flex-col p-14 justify-center relative">
                    <div v-if="post.author == pjwt.username"><div @click="deletePost(post._id)" class=" cursor-pointer absolute right-0 top-0 text-xl bg-red-500 p-4">Delete</div></div>
                    <!--<img class="lg:h-48 md:h-36 w-full object-cover object-center" src="https://dummyimage.com/720x400" alt="blog">-->
                    <div class="self-start">
                        <!--<h2 class="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">CATEGORY</h2>-->
                        <h1 class="mb-2">{{ post.author }} at {{ post.createdAt }}</h1>
                        <h1 class="title-font text-2xl font-medium text-gray-900 mb-3 dark:text-gray-300">{{ post.title }}</h1>
                        <p class="leading-relaxed mb-3 text-lg">{{ post.text }}</p>
                        <div class="flex items-center flex-wrap self-start">
                        <span v-if="likedStuff.likedPosts.includes(post._id)" class="text-[#eb4034] mr-3 inline-flex items-center leading-none text-sm pr-3 py-1 border-r-2 border-gray-200 dark:border-gray-400">
                            <!--<svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                            </svg>-->♥ {{ post.likes }} 
                        </span>
                        <span v-else  @click="likePost(post._id)" class="text-gray-400 mr-3 inline-flex items-center leading-none text-sm pr-3 py-1 border-r-2 border-gray-200 dark:border-gray-400 cursor-pointer hover:text-[#eb4034]">
                            <!--<svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                            </svg>-->♡ {{ post.likes }} 
                        </span>
                        <span class="text-gray-400 inline-flex items-center leading-none text-sm ">
                            <svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                            <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path>
                            </svg>{{ post.comments.length }}
                        </span>
                        </div>
                    </div>
                    <div class="self-start flex flex-col pt-12" v-if="!commentsLoading">
                        <div class="self-start flex flex-col gap-3 pt-6" v-for="comment in comments" :key="comment._id">
                            <div class="self-start text-sm">{{ comment.author }} at {{ comment.createdAt }}</div>
                            <div class="text-lg self-start">
                                {{ comment.text }}
                            </div>
                            <div class="self-start text-sm" v-if="likedStuff.likedComments.includes(comment._id)">
                                ♥️ {{ comment.likes }}
                            </div>
                            <div class="self-start text-sm hover:text-red-500" v-else>
                                <button class="comment-likes" @click="likeComment(comment._id)">♡ {{ comment.likes }}</button>
                            </div>
                        </div>
                    </div>
                    <div v-else><img :src="loadingImage" alt=""></div>
                </div>
            </div>
            <div v-else><img :src="loadingImage" alt=""></div>
        </div>
        <div class="flex flex-col dark:bg-slate-800 ">
            <div class="flex flex-col md:w-2/3 self-center">
                <input type="text" maxlength="300" v-model="newcomm" ref="commentAdder" placeholder="Write a Comment" class="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:ring-2 focus:bg-transparent focus:ring-green-200 focus:border-green-500 text-base outline-none text-gray-700 dark:focus:bg-opacity-10 dark:focus:bg-white dark:bg-opacity-0 dark:text-gray-100 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out mt-6">
                <button @click="addComment" class="inline-flex text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded mt-2 w-fit">Comment</button> <br>
                <!--<button @click="snacc('Salud!')" class="inline-flex text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded mt-2 ">Snacc Yourself</button>-->
                <div class="border border-solid border-green-500 text-xl bg-white dark:bg-opacity-75 dark:text-gray-600 font-medium rounded-lg opacity-0 transition-all w-11/12 bottom-3 fixed self-center pt-2 pb-2 hidden" ref="snackbar">
                    {{ navMessage }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const devServer = process.env.VUE_APP_PROD_SERVER || "http://localhost:3030" ;
export default {
    name: 'PostView',
    props: {
        postuser: String
    },
    data() {
        return {
            pjwt: {
                token: "",
                username: ""
            },
            post: {
                title: "",
                text: "",
                author: ""
            },
            postid: "",
            comments: [],
            navMessage: "",
            likedStuff: {
                likedComments: [],
                likedPosts: []
            },
            commentsLoading: true,
            postLoading: true,
            loadingImage: require('../assets/Rolling-1s-200px.gif'),
        }
    },
    created() {
        this.fillPost();
        this.checkAuth();
        this.fetchComments();
    },

    methods: {

        snacc: async function(message) {
            this.navMessage = message;
            //console.log("making the opacity to 1....");
            this.$refs.snackbar.style.display = "block";
            this.$refs.snackbar.style.opacity = 1;
            await setTimeout(() => {
                this.$refs.snackbar.style.opacity = 0;
            }, 3000);
            await setTimeout(() => {
                this.$refs.snackbar.style.display = "none";
            }, 3500);
            //console.log("turned the opacity to 0 again....");
        },


        deletePost: async function(postid) {
            // show the progressbar here
            await fetch(`${devServer}/api/posts/${postid}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${this.pjwt.token}`,
                    'username': this.pjwt.username
                },
                mode: 'cors',
                method: 'DELETE',
            });
            this.$router.back();
        },



        likePost: async function(postid) {
            this.likedStuff.likedPosts.push(postid);
            this.post.likes++;
            await fetch(`${devServer}/api/posts/like`, {
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${this.pjwt.token}`,
                    'postid': postid,
                    'username': this.pjwt.username
                },
                mode: 'cors',
            });
            //this.snacc(`Liked the post with status: ${respomse.status}`);
       },


        // methods
        fillPost: async function() {
            // to fill the post object using the given postid
            this.postid = this.postuser.slice(0, 24);
            this.pjwt.token = this.postuser.slice(24, this.postuser.length+1);
            // get the post object filled
            const respomse = await fetch(`${devServer}/api/posts/fetchpost/`, {
                mode: "cors",
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${this.pjwt.token}`,
                    'postid': this.postid
                    },
            });
            if(respomse.status == 200) {
                this.post = await respomse.json();
                //this.snacc("post has been fetched!!!")
            } else {
                this.snacc("Post fetching error");
            }
            this.postLoading = false;
        },

        fetchComments: async function() {
            // tbd: backend to get all the comments docs from comments array given just the post id
            const respomse = await fetch(`${devServer}/api/posts/comments/`, {
                mode: "cors",
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${this.pjwt.token}`,
                    'postid': this.postid
                    },
            });
            if(respomse.status == 200) {
                this.comments = await respomse.json();
                //this.snacc("Comments have been fetched!!!")
            } else {
                this.snacc("Comment fetching error")
            }
            this.commentsLoading = false;
        },

        addComment: async function() {
            // to add a comment
            const commentBody = {
                'text': this.newcomm,
                'postid': this.postid,
                'author': this.pjwt.username
            }
            this.newcomm = "";
            this.comments.push({...commentBody, 'likes': 0, 'createdAt': 'just now'})
            const respomse = await fetch(`${devServer}/api/posts/comment/`, {
                method: "POST",
                mode: "cors",
                headers: {'Content-Type': 'application/json', 'authorization': `Bearer ${this.pjwt.token}`},
                body: JSON.stringify(commentBody)
            });
            if(respomse.status == 201) {
                this.snacc("Comment Posted")
            } else {
                this.snacc("Comment Posting error")
            }
            await this.fetchComments();
        },

        likeComment: async function(commentid) {
            // to like the comment
            this.likedStuff.likedComments.push(commentid);
            this.comments.filter((el) => {return el._id == commentid})[0].likes++;
            const respomse = await fetch(`${devServer}/api/posts/comment/like/`,{
                headers: {
                    "Content-Type": "application/json",
                    "authorization": `Bearer ${this.pjwt.token}`,
                    "commentid": commentid,
                    "username": this.pjwt.username
                },
                mode: "cors"
            });
            if(respomse.status == 200) {
                //this.snacc("Comment Liked with status: " + respomse.status);
                this.snacc("Liked the Comment");
            } else {
                this.snacc("Comment liking error");
            }
        },

        
        checkAuth: async function() {
            let respomse = await fetch(`${devServer}/api/auth/checkAuth/`, {
                headers: {"Content-Type": "application/json", "authorization": `Bearer ${this.pjwt.token}`},
                mode: "cors"
            });
            let res = await respomse.json();
            this.pjwt.username = res.username;
            let likedrespomse = await fetch(`${devServer}/api/posts/getlikedstuff/`, {
                headers: {"Content-Type": "application/json", "authorization": `Bearer ${this.pjwt.token}`, "username": res.username},
                mode: "cors"
            });
            this.likedStuff = await likedrespomse.json();
            //this.snacc(this.likedStuff);
            this.$emit("passJWTToParent", this.pjwt);
        },
    }
}
</script>
